import ContainerTooltips from "../components/common/tooltip/ContainerTooltips";
import { Route } from "react-router-dom";
import React from "react";
import createReactClass from "create-react-class";
import RefreshPage from "../components/router/RefreshPage";
import ItemGrid from "../components/article/ItemGrid";
import EnvInfoDisplay from "../components/common/EnvInfoDisplay.jsx";
import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";
import ElstrUrlHashStore from "elstr-jslib/src/scripts/stores/ElstrUrlHashStore";
import ElstrConfigStore from "elstr-jslib/src/scripts/stores/ElstrConfigStore";
import AppsStore from "../stores/AppsStore";
import MaterialsStore from "../stores/MaterialsStore";
import SelectionStore from "../stores/SelectionStore";
import ElstrUserStore from "elstr-jslib/src/scripts/stores/ElstrUserStore";
import VetroUserLogin from "../components/user/VetroUserLogin";
import OverlayMenu from "../components/overlay/OverlayMenu";
import HeaderWrap from "../components/header/HeaderWrap";
import ClassChangerOnScrollApp from "../components/common/ClassChangerOnScrollApp";
import { setDocTitle } from "../libs/Meta";

const App = createReactClass({
  mixins: [AppsStore.mixin, ElstrUrlHashStore.mixin, ElstrLangStore.mixin, MaterialsStore.mixin, ElstrUserStore.mixin],

  componentDidMount: function () {
    // create up to 3 random bottles
    MaterialsStore.filterIntroPage();

    // set title
    let isPisysSite = ElstrConfigStore.option("isPisysSite");
    let title = ElstrLangStore.text("TITLE__EKATALOG");
    if (isPisysSite) title = ElstrLangStore.text("TITLE__PISYS");
    setDocTitle(`${title}`);

    let currentLanguage = ElstrLangStore.getCurrentLanguage();
    window._paq.push(["trackPageView", "Katalog Intro ( " + currentLanguage + " )"]);
  },

  storeDidChange: function () {
    this.forceUpdate();
  },

  render: function () {
    if (AppsStore.shouldLoginBeRendered()) {
      return <VetroUserLogin />;
    }

    // post the 3 random bottles as grid in (grids)
    let grids = [];
    // get up to 3 random bottles
    let materialsToRender = MaterialsStore.getFilteredMaterialsRandomIntro();
    let selectedMaterials = SelectionStore.getMySelectedMaterials();
    let added = false;

    materialsToRender.forEach(material => {
      // check if added in my selection
      added = false; // reset
      selectedMaterials.forEach(obj => {
        if (material.sMatAtvMatnrZvgb === obj.materialNumber) added = true;
      });

      grids.push(<ItemGrid key={material.sMatHdrMatnr} material={material} added={added} />);
    });

    return (
      <ClassChangerOnScrollApp>
        <Route path="/catalogue" component={RefreshPage} />
        <EnvInfoDisplay key="EnvInfoDisplay" />
        {/* <a href="catalogue.php" className="visually-hidden">Skip to main content</a> */}
        <HeaderWrap />
        <div className="homepage__main">
          <h2 className="visually-hidden">Main</h2>
          <div className="homepage-main__body">
            <div className="homepage-main__title">{ElstrLangStore.text("THE_PERFECT_CHOICE")}</div>
            <div className="homepage-main__content slide-wrap">
              <div className="slide-content">
                {/* <!-- Start of Item Tile --> */}
                {grids}
                {/* <!-- End of Item Tile --> */}
              </div>
              {/* <!-- // slide-content --> */}
            </div>
            {/* <!-- // homepage-main__content --> */}
            <div className="homepage-main__subtitle">{ElstrLangStore.text("UNDER_ITEM_GRIDS")}</div>
          </div>
          {/* <!-- // homepage-main__body --> */}
        </div>
        {/* <!-- // homepage__main --> */}
        {/* <!-- menu-overlay --> */}
        <OverlayMenu key="OverlayMenu" />
        <div className="modal-overlay" onClick={AppsStore.setCloseAllMenus} />
        <div className="filter-open-icon desktop--hidden" />
        <ContainerTooltips />
        {/* <!-- // container --> */}
      </ClassChangerOnScrollApp>
    );
  },
});

export default App;
